import React from 'react';
import { Info } from 'lucide-react';
import ExplainedIcon from 'src/shared/components/explained-icon/ExplainedIcon';
import { ReleasePolicy } from 'src/shared/types/engine/products';
import { defaultBehaviour } from './defaultBehaviour';

/**
 * Marks the release state as the default, and says what the customer sees
 * then. In the state text, "(default)" made the line too long for a nested
 * row, and the row cut it off.
 */
type DefaultStateIconProps = {
    releasePolicy: ReleasePolicy;
    hasUpsellPage: boolean;
    isTurnedOnPerProject: boolean;
};

export const DefaultStateIcon = ({ releasePolicy, hasUpsellPage, isTurnedOnPerProject }: DefaultStateIconProps) => (
    <ExplainedIcon message={`(Default) ${defaultBehaviour(releasePolicy, hasUpsellPage, isTurnedOnPerProject)}`} className='text-grey-70'>
        <Info size={14} />
    </ExplainedIcon>
);
